/**
 * 在线答题系统API服务
 */

import api from './api';

const quizAPI = {
  // ==================== 题目管理 ====================
  
  /**
   * 获取题目列表
   * @param {Object} params - 查询参数 { classId, schoolId, includeHidden }
   */
  getQuestions: (params = {}) => {
    return api.get('/quiz/questions', { params });
  },

  /**
   * 获取题目详情
   * @param {number} id - 题目ID
   */
  getQuestion: (id) => {
    return api.get(`/quiz/questions/${id}`);
  },

  /**
   * 创建题目
   * @param {Object} data - 题目数据
   */
  createQuestion: (data) => {
    return api.post('/quiz/questions', data);
  },

  /**
   * 更新题目
   * @param {number} id - 题目ID
   * @param {Object} data - 更新数据
   */
  updateQuestion: (id, data) => {
    return api.put(`/quiz/questions/${id}`, data);
  },

  /**
   * 删除题目
   * @param {number} id - 题目ID
   */
  deleteQuestion: (id) => {
    return api.delete(`/quiz/questions/${id}`);
  },

  /**
   * 切换题目显示/隐藏状态
   * @param {number} id - 题目ID
   */
  toggleQuestion: (id) => {
    return api.patch(`/quiz/questions/${id}/toggle`);
  },

  // ==================== 答题会话 ====================
  
  /**
   * 开始答题会话
   * @param {Object} data - { questionId, classId, mode, groupId, duration }
   */
  startSession: (data) => {
    return api.post('/quiz/session/start', data);
  },

  /**
   * 结束答题会话
   * @param {number} sessionId - 会话ID
   */
  stopSession: (sessionId) => {
    return api.post('/quiz/session/stop', { sessionId });
  },

  /**
   * 获取当前活动会话
   * @param {number} classId - 班级ID
   */
  getCurrentSession: (classId) => {
    return api.get('/quiz/session/current', { params: { classId } });
  },

  /**
   * 获取会话详情
   * @param {number} sessionId - 会话ID
   */
  getSession: (sessionId) => {
    return api.get(`/quiz/session/${sessionId}`);
  },

  /**
   * 获取会话答题报告
   * @param {number} sessionId - 会话ID
   */
  getSessionReport: (sessionId) => {
    return api.get(`/quiz/session/${sessionId}/report`);
  },

  // ==================== 统计查询 ====================
  
  /**
   * 获取实时统计
   * @param {number} sessionId - 会话ID
   */
  getStatistics: (sessionId) => {
    return api.get(`/quiz/statistics/${sessionId}`);
  },

  /**
   * 清空答题数据（调试用）
   * @param {number} sessionId - 会话ID
   */
  clearVotes: (sessionId) => {
    return api.post('/quiz/votes/clear', { sessionId });
  },

  // ==================== ESP32答题提交 ====================
  
  /**
   * ESP32提交答案
   * @param {Object} data - { answer, rawNumber, timestamp, deviceId, deviceIP }
   */
  submitVote: (data) => {
    return api.post('/quiz/vote', data);
  }
};

export default quizAPI;


